module.exports = __webpack_public_path__ + "media/images/new_home/photo-2-6a739a77d0aaf5374b16ab0243774b7e.png";